module.exports = __webpack_public_path__ + "static/img/14010206.c873e438.png";